/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { StyledSquareSkeleton } from './styles'

export const ChartSkeletalLoader = ({ dataTestId }) => {

  return (
    <StyledSquareSkeleton 
      variant="rounded" 
      animation="wave"
      data-testid={dataTestId}
    />
  )
}
